export enum REQUESTS_PATH {
    ORDER_REFERENCE_LABELS = '/CustomerDelivery/GoodParts/GetOrderReferenceNumberLabels',
    PRODUCTS_OUTBOUND = '/CustomerDelivery/GoodParts/Parts',
    GET_SERVICES = '/CustomerDelivery/GoodParts/AvailableServices',
    SERIAL_NUMBERS = '/CustomerDelivery/GoodParts/GetInventoryPartSerialNumbers',
    PRE_CHECK = '/CustomerDelivery/GoodParts/PreCheck',
    SUBMIT_FULL_ORDER = '/CustomerDelivery/GoodParts/Submit',
    SUBMIT_REDUCED_ORDER = '/CustomerDelivery/GoodParts/SubmitReduced'
}
